import React, { useState } from 'react';
import { buildAccuracyDebugSnapshot } from '../../../utils/accuracyModeMeta';
import styles from '../css/index.module.css';

const AccuracyDebugPanel = ({ retrievalDebug }) => {
    const [open, setOpen] = useState(false);
    const sections = buildAccuracyDebugSnapshot(retrievalDebug);
    if (!sections.length) return null;

    return (
        <div className={styles.aiWardenAccuracyDebug}>
            <button
                type="button"
                className={styles.aiWardenAccuracyDebugToggle}
                aria-expanded={open}
                onClick={() => setOpen(v => !v)}>
                {open ? 'Hide' : 'Show'} retrieval debug
            </button>
            {open ? (
                <div className={styles.aiWardenAccuracyDebugBody}>
                    {sections.map(section => (
                        <div key={section.title} className={styles.aiWardenAccuracyDebugSection}>
                            <div className={styles.aiWardenAccuracyDebugSectionTitle}>{section.title}</div>
                            <ul className={styles.aiWardenAccuracyDebugList}>
                                {section.lines.map((line, idx) => (
                                    <li key={`${section.title}-${idx}`}>{line}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            ) : null}
        </div>
    );
};

export default AccuracyDebugPanel;
